export enum ReportProgressStage {
    PENDING = 0,
    SUBMITTED = 3,
    TWO = 10,
    THREE = 22,
    FOUR = 38,
    FIVE = 53,
    SIX = 67,
    SEVEN = 74,
    CACHING = 90,
    COMPLETE = 100
}

export enum ReportProgressStageName {
    PENDING = 'pending',
    SUBMITTED = 'submitted',
    RUNNING = 'running',
    CACHING = 'caching',
    COMPLETE = 'complete'
}